export var HEADER_APP_IDENTIFIER = "X-IF-APP-IDENTIFIER";
